import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EAggregationTypes = {
	aggregated: 'aggregated',
	siteLevel: 'site_level',
	siteLevelAggregatedCells: 'site_level_aggregated_cells',
} as const;

export const EFormFields = {
	aggregationType: 'aggregationType',
	from: 'from',
	to: 'to',
	sitesT_4G_FDD: 'sitesT_4G_FDD',
	sitesT_4G_TDD: 'sitesT_4G_TDD',
	sitesT_5G: 'sitesT_5G',
	kpi: 'kpi',
	counters: 'counters',
	treeKpiIds: 'treeKpiIds',
	treeCountersIds: 'treeCountersIds',
	initTreeKpiData: 'initTreeKpiData',
	initTreeCountersData: 'initTreeCountersData',
	timeAggregationType: 'timeAggregationType',
	vendor: 'vendor',
	granularity: 'granularity',
	isAutomaticGranularity: 'isAutomaticGranularity',
	dateSelectionMode: 'dateSelectionMode',
	dynamicDateRange: 'dynamicDateRange',
	startDateOffset: 'startDateOffset',
	isShared: 'isShared',
} as const;

export type TAggregationTypes = TValueOfStringRecord<typeof EAggregationTypes>

export const EDateSelectionModes = {
	static: 'STATIC',
	dynamic: 'DYNAMIC',
};

export const EDynamicDateRange = {
	last_7_days: 'LAST_7_DAYS',
	last_30_days: 'LAST_30_DAYS',
	current_day: 'CURRENT_DAY',
	current_month: 'CURRENT_MONTH',
	custom: 'CUSTOM',
};
